module.exports = __webpack_public_path__ + "img/connect-background.b05e08c5.png";